import type { FC } from 'react';
import { CircularProgress, MenuItem, Select } from '@mui/material';
import type { TwitterCreativePriority } from '../api';
import { PRIORITY_OPTIONS } from '../utils';

interface PrioritySelectProps {
  creativeName: string;
  value: TwitterCreativePriority;
  /** The new priority is being saved: the arrow turns into a spinner and the select is locked. */
  loading?: boolean;
  onChange: (priority: TwitterCreativePriority) => void;
}

const SavingIcon: FC<{ className?: string }> = ({ className }) => (
  <CircularProgress size={16} aria-label="Saving priority" className={className} sx={{ right: 12 }} />
);

// Events are stopped so using the dropdown does not toggle the row selection or move grid focus.
const PrioritySelect: FC<PrioritySelectProps> = ({ creativeName, value, loading, onChange }) => (
  <Select<TwitterCreativePriority>
    size="small"
    value={value}
    disabled={loading}
    IconComponent={loading ? SavingIcon : undefined}
    onChange={(event) => {
      onChange(event.target.value as TwitterCreativePriority);
    }}
    onClick={(event) => {
      event.stopPropagation();
    }}
    onKeyDown={(event) => {
      event.stopPropagation();
    }}
    MenuProps={{
      onClick: (event) => {
        event.stopPropagation();
      },
    }}
    inputProps={{ 'aria-label': `Priority of ${creativeName}` }}
    sx={{ width: '100%', fontSize: 14 }}
  >
    {PRIORITY_OPTIONS.map(({ value: optionValue, label }) => (
      <MenuItem key={optionValue} value={optionValue}>
        {label}
      </MenuItem>
    ))}
  </Select>
);

export default PrioritySelect;
